// Form.js
import React, { useState } from 'react';
import { Container, TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl, Typography, Box } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ModalAlert from './modal';


const Form = () => {

const [modalOpen, setModalOpen] = useState(false);
const [modalMessage, setModalMessage] = useState('');

const showAlert = (message) => {
  setModalMessage(message);
  setModalOpen(true);
};

const handleClose = () => {
  setModalOpen(false);
  setModalMessage('');
};


  const navigate = useNavigate();

  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [region, setRegion] = useState('');
  const [photo, setPhoto] = useState(null);
  const [job, setJob] = useState('');
  const [recom, setRecom] = useState('');
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
      // setPhoto(file);
      console.log(file);

      console.log('File type:', file.type);

      if (file) {
        resizeImage(file, 800, 800, 0.7);

        // const reader = new FileReader();
        //
        // // 파일을 읽는 중에 오류가 발생한 경우
        // reader.onerror = (error) => {
        //   console.error("파일을 읽는 중 오류가 발생했습니다:", error);
        // };

        // 파일이 성공적으로 읽힌 경우
        // reader.onloadend = () => {
        //    console.log('Data URL:', reader.result);
        //   setPreviewUrl(reader.result);
        // };

        // 파일 읽기 시작
        // reader.readAsDataURL(file);
      }

    // 파일 처리 로직...
  };


  const resizeImage = (file, maxWidth, maxHeight, quality) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {

        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {

          console.log("img");

          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          // 비율을 유지하면서 크기 조정
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          // 압축된 이미지 URL 생성
          canvas.toBlob((blob) => {
            const newFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now(),
            });

            setPhoto(newFile);

            const previewUrl = URL.createObjectURL(newFile);
            setPreviewUrl(previewUrl);
          }, file.type, quality); // 품질 설정
        };

        img.onerror = (err) => {
          showAlert('이미지 파일 형식을 변경해주세요.');
              // console.error('이미지 로드 실패:', err);
        };

      };

    }



  const handleSubmit = async (e) => {
    e.preventDefault();

    if(gender == ''){
      showAlert('성별을 선택해주세요.');
      return;
    }else if(age == ''){
      showAlert("나이를 입력해주세요.");
      return;
    }else if(region == ''){
      showAlert("지역을 선택해주세요.");
      return;
    }else if(photo == null){
      showAlert("사진을 선택해주세요.");
      return;
    }else if(job == ''){
      showAlert("직업을 선택해주세요.");
      return;
    }

    const formData = new FormData();
    formData.append('gender', gender);
    formData.append('age', age);
    formData.append('region', region);
    formData.append('photo', photo);
    formData.append('job', job);
    formData.append('recom', recom);


    try {
      const response = await axios.post('http://13.124.203.56/sungpt/in_user.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // console.log('Server response:', response.data);

      const id = response.data.id;

      // console.log(response.data.id);
      console.log(id)
      showAlert("등록되었습니다.");

      setTimeout(() => {
        navigate(`/sungptPhone?id=${id}`);
        // navigate('/sungptPhone', { state: { id: id } }); // 이동할 페이지의 상대 경로
      }, 700); // 1초 후 이동

    } catch (error) {
      showAlert("등록에 실패하였습니다.");
      // console.error('There was an error uploading the form!', error);
    }
  };

  return (
    <Container component="main" maxWidth="xs" sx={{ mt: 4}}>
      <div>
        <form onSubmit={handleSubmit} noValidate>
        <ModalAlert
          open={modalOpen}
          onClose={handleClose}
          message={modalMessage}
          />

        <Typography variant="h7" gutterBottom>
          신청자 정보
        </Typography>

          <Grid container spacing={2} sx={{ mt: 0.01}}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="gender-label">성별</InputLabel>
                <Select
                  labelId="gender-label"
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  label="성별"
                >
                  <MenuItem value="1">남성</MenuItem>
                  <MenuItem value="2">여성</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="나이"
                type="number"
                value={age}
                inputProps={{ maxLength: 2 }}
                onChange={(e) => setAge(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="region">지역</InputLabel>
              <Select
                labelId="region"
                value={region}
                onChange={(e) => setRegion(e.target.value)}
                label="지역"
              >
                <MenuItem value="seoul">서울</MenuItem>
                <MenuItem value="gyungi">경기</MenuItem>
                <MenuItem value="incheon">인천</MenuItem>
                <MenuItem value="busan">부산</MenuItem>
                <MenuItem value="gyungnam">경남</MenuItem>
                <MenuItem value="ulsan">울산</MenuItem>
                <MenuItem value="dajeon">대전</MenuItem>
                <MenuItem value="chnam">충남</MenuItem>
                <MenuItem value="chbook">충북</MenuItem>
                <MenuItem value="sejong">세종</MenuItem>
                <MenuItem value="gwangju">광주</MenuItem>
                <MenuItem value="jeonam">전남</MenuItem>
                <MenuItem value="jeonbuk">전북</MenuItem>
                <MenuItem value="jeju">제주</MenuItem>
              </Select>
            </FormControl>
            </Grid>

            <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="job">직업</InputLabel>
              <Select
                labelId="job"
                value={job}
                onChange={(e) => setJob(e.target.value)}
                label="직업"
              >
                <MenuItem value="a1">대기업</MenuItem>
                <MenuItem value="a2">중견기업</MenuItem>
                <MenuItem value="a3">중소기업</MenuItem>
                <MenuItem value="b1">공기업</MenuItem>
                <MenuItem value="b2">공무원</MenuItem>
                <MenuItem value="c1">전문직</MenuItem>
                <MenuItem value="d1">자영업</MenuItem>
              </Select>
            </FormControl>
            </Grid>

            <Grid item xs={12} sx={{mt:2, mb: 6}} >
              <Button
                variant="contained"
                component="label"

                fullWidth
                sx={{height:'40px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
              >
                사진 업로드
                <input
                  type="file" accept="image/*"
                  hidden
                  onChange={handleImageChange}
                />
              </Button>
              {photo && (
                <Typography variant="body2" color="textSecondary" align="center" sx={{mt:1}}>
                  {photo.name}
                </Typography>
              )}

              {previewUrl && (
                <Box mt={2} textAlign="center">
                  <img src={previewUrl} alt="미리보기 이미지" style={{ maxWidth: '100%', height: 'auto' }} />
                </Box>
              )}
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{mb: 4}}>
            <TextField
              variant="outlined"
              fullWidth
              label="추천인 코드"
              type="tel"
              value={recom}
              onChange={(e) => setRecom(e.target.value)}
            />
          </Grid>


          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2, mb: 2 }}
            sx={{height:'50px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
          >
            신청
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default Form;
